<!-- //-----------------------------------------------------------------------
// <copyright file="app.component.html" company="LGT India">
//     Author: vanaraj  
//     Copyright (c) LGT India. All rights reserved.
// </copyright>
//----------------------------------------------------------------------- -->
<router-outlet></router-outlet>
